<template>
<div class="col-md-12 login-container">
    <!-- <router-link :to="{ name: 'local-student' , params: { localId: 1 }}">Draft applications</router-link> -->
    <b-table mobile-cards :data="draftStudents" sticky-header>
        <b-table-column field="actions" label="Actions" v-slot="props" width="240">
            <b-button tag="router-link" :to="{ name: 'local-student' , params: { localId: props.row.localId }}" type="is-warning">
                Edit
            </b-button>
            <b-button class="ml-2" @click="deleteApplication(props.row.localId)" type="is-danger">Delete</b-button>
        </b-table-column>
        <b-table-column field="name" label="Name" width="40" v-slot="props">
            {{ studentName(props.row.personalInformation) }}
        </b-table-column>
        <b-table-column field="student_id" label="Phone number" width="40" v-slot="props">
            {{ props.row.personalInformation.phone_number }}
        </b-table-column>
        <b-table-column field="student_id" label="Email address" width="40" v-slot="props">
            {{ props.row.personalInformation.email }}
        </b-table-column>
    </b-table>
</div>
</template>

<script>
export default {
    name: 'ResetPass',
    data() {
        return {};
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        },
        draftStudents() {
            return this.$store.state.student.draftStudents
        }
    },
    created() {

    },
    methods: {
        deleteApplication(localId) {
            this.$buefy.dialog.confirm({
                message: 'Are you sure you want to delete this student? This action cannot be undone',
                onConfirm: () => {
                    this.$store.dispatch('student/removeStudent', {
                        localId
                    })
                }
            })
            
        },

        studentName(student) {
            return student.first_name + " " + student.last_name + " ";
        },
    }
};
</script>

<style scoped>
</style>
